import { createContext, ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import styles from './styles.module.css';

type DrawerProviderProps = {
  children: ReactNode;
};

type DrawerContextType = {
  closeDrawer: () => void;
  openDrawer: () => void;
  toggleDrawer: () => void;
   
  updateDrawerContent: (content: ReactNode) => void;
  isOpen: boolean;
};

const initialValue = {
  closeDrawer: () => {},
  openDrawer: () => {},
  toggleDrawer: () => {},
  updateDrawerContent: (_content: ReactNode) => {},
  isOpen: false
};

const DrawerContext = createContext<DrawerContextType>(initialValue);

export const DrawerProvider = ({ children = null }: DrawerProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [drawerContent, setDrawerContent] = useState<null | ReactNode>(null);
  const location = useLocation();

  const closeDrawer = () => setIsOpen(false);

  const openDrawer = () => setIsOpen(true);

  const toggleDrawer = () => setIsOpen(prevState => !prevState);

  const updateDrawerContent = (content: ReactNode) => {
    toggleDrawer();
    setDrawerContent(content);
    toggleDrawer();
  };

  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
      setDrawerContent(null);
    }
  }, [location]);

  return (
    <DrawerContext.Provider
      value={{
        closeDrawer,
        openDrawer,
        toggleDrawer,
        updateDrawerContent,
        isOpen
      }}
    >
      <div
        id="overlay"
        onClick={closeDrawer}
        className={
          isOpen ? styles.overlay + ' ' + styles.active : styles.overlay
        }
      ></div>

      <div
        className={
          isOpen ? styles.sidenav + ' ' + styles.active : styles.sidenav
        }
      >
        {drawerContent}
      </div>

      {children}
    </DrawerContext.Provider>
  );
};

export default DrawerContext;
